import logo from "./assets/anl-logo.jpg";

/** Uses the supplied original logo asset; no recreated wordmark or remote request. */
export function Week39Brand() {
  return <img className="pack39-logo" src={logo} alt="ANL" width={44} height={44} decoding="async" />;
}
